import script from "./AdminSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&setup=true&lang=js"

import "./AdminSidebar.vue?vue&type=style&index=0&id=23cd048a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23cd048a"]])

export default __exports__